module.exports = "https://static.wanderu.com/static/media/powered_by_google_on_white_hdpi.a9883877.png";